import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export default function IconAdmin({
    width = 20,
    height = 20,
    className,
    ...rest
}) {
    return (
        <svg
            viewBox="0 0 20 20"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, css.colored, className)}
            fillRule={'evenodd'}
            {...rest}
        >
            <title>Icon admin</title>
            <path d="M4.02749 5.10435L6.8554 7.88708L10 3.64666L13.1446 7.88708L15.9725 5.10435L15.909 13.0442H4.09103L4.02749 5.10435ZM2.00004 2.71549C1.99201 1.83796 3.08154 1.39507 3.71497 2.01838L6.61572 4.87278L9.18748 1.40484C9.58777 0.865054 10.4122 0.865054 10.8125 1.40484L13.3843 4.87278L16.285 2.01838C16.9185 1.39507 18.008 1.83796 18 2.71549L17.9011 14.5154C17.8986 14.7837 17.6749 15 17.3997 15H2.60027C2.32512 15 2.10138 14.7837 2.09892 14.5154L2.00004 2.71549ZM3 17C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H3Z" />
        </svg>
    );
}
